'use client'

import { cn } from '../cn'
import { FrameLink, useFramePath } from './config'

/** The tabs of a module: its start page and its subpages, as the host resolved them for this role. */
export function ModuleNav({
  moduleId,
  homeLabel,
  subpages
}: {
  moduleId: string
  homeLabel: string
  subpages: { slug: string; title: string }[]
}) {
  const pathname = useFramePath()
  const base = `/module/${moduleId}`
  const tabs = [{ href: base, label: homeLabel }, ...subpages.map(s => ({ href: `${base}/${s.slug}`, label: s.title }))]

  return (
    <nav data-slot="module-nav" className="-mb-px flex gap-1">
      {tabs.map(tab => (
        <FrameLink
          key={tab.href}
          href={tab.href}
          aria-current={pathname === tab.href ? 'page' : undefined}
          className={cn(
            'border-b-2 px-4 py-3 text-sm font-medium transition-colors',
            pathname === tab.href
              ? 'border-black text-gray-900'
              : 'border-transparent text-gray-500 hover:text-gray-900'
          )}
        >
          {tab.label}
        </FrameLink>
      ))}
    </nav>
  )
}
